/**
 * Web Rooms Scripts
 *
 * @copyright 2023 Linguistica 360
 */

import $ from 'jquery';
import MicroModal from 'micromodal';

import { Script, injector } from '../shared/injector.js';

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || window.opera;

    // Windows Phone must come first because its UA also contains "Android"
    if (/windows phone/i.test(userAgent)) {
        return 'Windows Phone';
    }

    if (/android/i.test(userAgent)) {
        return 'Android';
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return 'iOS';
    }

    return 'unknown';
}

injector.injectClass(class extends Script {
    onLoad() {
        const $overlay = $('#modal_rooms_app');

        const os = getMobileOperatingSystem();
        if (os !== 'Android' && os !== 'iOS') return;

        if (localStorage.getItem('hide-app-recommendation')) return;

        if (!sessionStorage.getItem('hide-app-recommendation')) {
            if (os !== 'iOS') $overlay.find('.app-icon-ios').hide();
            if (os !== 'Android') $overlay.find('.app-icon-android').hide();

            MicroModal.show('modal_rooms_app');
        }

        sessionStorage.setItem('hide-app-recommendation', true);

        $overlay.find('#rooms_app_remember').on('change', () => {
            const checked = $('#rooms_app_remember').is(':checked');
            if (checked) {
                localStorage.setItem('hide-app-recommendation', checked);
            }
        });
    }
}, ['web-rooms']);
